import { createContext } from "react";

const GlobalAppContext = createContext({
  theme: "DefaultLightTheme",
  locale: "enUS",
  sideNavigationOpen: true,
});
export default GlobalAppContext;
